export const config = {
  baseURL: "https://madad-backend.bis-apps.com/",
  tokenKEY: "token",
  phoneKEY: "phone",
  backendTokenKEY: "Authorization",
};
